export default (params) => {
  const { removeDocumentPicture } = params;
  return [
    {
      type: 'label',
      text: 'Upload a photo',
    },
    {
      type: 'click',
      text: 'Remove',
      triggerFunction: removeDocumentPicture,
    },
  ];
};
